export interface Theme {
  bg: string
  bg2: string
  card: string
  line: string
  ink: string
  ink2: string
  acc: string
  acc2: string
  warn: string
  onacc: string
  font: string
}

/** Одна тема — выбор оформления только загромождал интерфейс. */
export const THEME: Theme = {
  bg: '#0e1030',
  bg2: '#191d4d',
  card: 'rgba(255,255,255,.07)',
  line: 'rgba(255,255,255,.14)',
  ink: '#f2f3ff',
  ink2: '#a3a7d4',
  acc: 'oklch(0.82 0.17 145)',
  acc2: 'oklch(0.72 0.17 300)',
  warn: 'oklch(0.78 0.17 60)',
  onacc: '#0b1226',
  font: "'Nunito', system-ui, sans-serif",
}

/** CSS-переменные темы для корневого элемента. */
export function themeVars(theme: Theme): React.CSSProperties {
  return {
    '--bg': theme.bg,
    '--bg2': theme.bg2,
    '--card': theme.card,
    '--line': theme.line,
    '--ink': theme.ink,
    '--ink2': theme.ink2,
    '--acc': theme.acc,
    '--acc2': theme.acc2,
    '--warn': theme.warn,
    '--onacc': theme.onacc,
    '--font': theme.font,
  } as React.CSSProperties
}
